import { setTheme } from "theme/default/setTheme";

export const setBorderRadius_20px = setTheme(({ theme }) => `border-radius: ${theme.borderRadius.border_radius_20px}`);
